import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['list' /* , 'trackHandle', 'trackNumberInput */, 'track', 'uploadingDialog'];

  #disconnected = false;

  get trackTargetsControllers() {
    return this.trackTargets.map((track) =>
      this.application.getControllerForElementAndIdentifier(track, 'track'),
    );
  }

  async connect() {
    this.#disconnected = false;

    this.element.addEventListener('direct-upload:start', this.handleDirectUploadStart);
    this.element.addEventListener('direct-upload:end', this.handleDirectUploadEnd);

    const { Sortable } = await import('sortablejs');

    if (this.#disconnected) return;

    this.sortable = new Sortable(this.listTarget, {
      handle: '[data-tracks-target="trackHandle"]',
      animation: 150,
      onEnd: this.reorderEndHandler,
    });
  }

  disconnect() {
    this.#disconnected = true;

    this.element.removeEventListener('direct-upload:start', this.handleDirectUploadStart);
    this.element.removeEventListener('direct-upload:end', this.handleDirectUploadEnd);

    this.sortable?.destroy();
  }

  reorderEndHandler = (event) => {
    if (event.oldIndex === event.newIndex) return;

    const input = event.item.querySelector('[data-tracks-target="trackNumberInput"]');
    input.value = event.newIndex + 1;

    input.closest('form').querySelector('button').click();
  };

  closeAll() {
    this.trackTargetsControllers.forEach((trackController) => trackController.close());
  }

  updateOpenTracks() {
    const hasOpen = this.trackTargetsControllers.some((trackController) => trackController.isOpen);

    this.element.classList.toggle('has-open', hasOpen);
  }

  handleDirectUploadStart = () => {
    this.uploadingDialogTarget.showModal();
  };

  handleDirectUploadEnd = () => {
    this.uploadingDialogTarget.close();
  };
}
